export default __webpack_public_path__ + "static/realWorldImg5-0154828add6befcea89cac89e750b3b3.webp";